import axios from 'axios';
let ajax = 
{
    hello: function()
    {
        console.log("Hello: sy.ajax");
    },
    
    // post 请求 - 无法跨域
    // post: (url, data) => {
    //     data.utoken = localStorage.getItem('utoken');
    //     return new Promise((resolve, reject) => {
    //         axios.post(url, data).then(response => {
    //             response = response.data;
    //             if (response.state == "401")
    //             {
    //                 ajax.getCode();
    //             }else{
    //                 resolve(response);
    //             }
    //         }, err => {
    //             reject(err)
    //         })
    //     })
    // },

    // get 请求 
    get: function(obj)
    {
        return new Promise((resolve, reject) => {
            axios.get(
                obj.url,
                {
                    params: obj.data,
                }
            ).then(function(response){
                resolve(obj.success(response.data))
            }).catch(err => {
                console.log(err);
                reject(err);
            })
        })
    },
    
    // 上传文件
    file: function(obj)
    {
        return new Promise((resolve, reject) => {
            
            let form = new FormData();          // 创建form对象
            if( obj.data.file !== undefined )
            {
                form.append( obj.data.file.name, obj.data.file.file );
            }
            for( var k in obj.data )
            {
                if( k !== 'file' )
                {
                    form.append( k, obj.data[k] );
                }
            }
            obj.data = form;
    
            axios.post(
                obj.url,
                obj.data,
                { headers: { "Content-Type": "multipart/form-data" } }
            ).then(response => {
                resolve(response.data);
    
            }).catch(err => {
                reject(err);
            })
        })
    },
};

export default ajax;